// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/School/Detail/Background.less
// module id = 912
// module chunks = 0